{
  "incidentsOverview": {
    "button": {
      "new": "Nouvel événement avalancheux",
      "columns": "Rubriques",
      "download": "Télécharger GeoJSON"
    },
    "tooltip": {
      "edit": "Éditer incident",
      "preview": "Afficher événement avalancheux"
    },
    "empty": "Pas d'incidents pour cette région.",
    "loading": "Charger incidents…",
    "error": "Impossible de charger les incidents.",
    "retry": "Réessayer",
    "filter": {
      "anyStatus": "Tout statut"
    }
  },
  "incidentReportUI": {
    "addAttachment": "Ajouter pièce jointe",
    "addAvalancheProblem": "Ajouter situation avalancheuse typique",
    "addGroup": "Ajouter groupe",
    "addVictim": "Ajouter une personne",
    "back": "Retour",
    "clearLine": "Effacer ligne",
    "clearPoint": "Effacer point",
    "clearPolygon": "Effacer polygone",
    "controls": "Régulateurs",
    "deleteIncident": "Supprimer incident",
    "deleteIncidentConfirm": "Supprimer cet incident ?",
    "drawLine": "Tracer ligne",
    "drawLineInstructions": "Cliquer sur la carte pour ajouter des points.",
    "drawPoint": "Tracer point",
    "drawPointInstructions": "Cliquez n'importe où sur la carte pour placer le repère, puis faites-le glisser pour le repositionner.",
    "drawPolygon": "Tracer polygone",
    "drawPolygonInstructions": "Cliquer sur la carte pour définir les sommets du polygone.",
    "dropAttachment": "Déposer pièce jointe {{fileName}} ?",
    "dropAvalancheProblem": "Déposer situation avalancheuse {{number}} ?",
    "dropGroup": "Déposer groupe {{number}} ?",
    "dropVictim": "Déposer personne {{number}} ?",
    "fetchPublishedBulletin": "Récupérer depuis le bulletin CAAML publié ",
    "fetchPublishedBulletinError": "Impossible de récupérer un bulletin CAAML publié pour {{region}} le {{date}}.",
    "fetchPublishedBulletinSuccess": "Bulletin mis à jour avec {{count}} situation(s) avalancheuse(s) typique(s) pour {{region}} le {{date}}.",
    "groupName": "Groupe {{name}}",
    "groupUnknown": "Groupe inconnu",
    "incomplete": "Incomplet",
    "line": "Ligne",
    "locationMap": "Plan du site",
    "noGroups": "Aucun groupe n'est enregistré. Cliquer sur « Ajouter groupe » pour en ajouter un.",
    "next": "Suivant",
    "overview": "Aperçu",
    "noVictims": "Aucune personne n'est enregistrée. Cliquer sur « Ajouter une personne » pour en ajouter une.",
    "point": "Point",
    "polygon": "Polygone",
    "publishIncident": "Publier",
    "publishIncidentConfirm": "Publier cet incident ?",
    "publishIncidentSuccess": "Le rapport d'incident a bien été publié.",
    "republishIncident": "Republier",
    "republishIncidentConfirm": "Republier cet incident ?",
    "unpublishIncident": "Retirer de la publication",
    "unpublishIncidentConfirm": "Retirer cet incident ?",
    "unpublishIncidentSuccess": "Le rapport d'incident a bien été retiré.",
    "removeAttachment": "Supprimer pièce jointe",
    "removeAvalancheProblem": "Supprimer situation avalancheuse typique",
    "removeGroup": "Supprimer groupe",
    "removeVictim": "Supprimer cette personne",
    "requiredFieldsMissingHint": "Impossible d'enregistrer le rapport et de modifier son statut tant que tous les champs obligatoires (indiqués dans le formulaire) n'ont pas été renseignés.",
    "displayMode": {
      "edit": "Éditer",
      "editMostRelevant": "Éditer le plus pertinent",
      "all": "Aperçu de tout",
      "public": "Aperçu champs publics seulement",
      "filledOut": "Aperçu champs renseignés seulement"
    },
    "victimName": "Personne {{name}}",
    "saveStateSaving": "Enregistrer...",
    "saveStateSaved": "Enregistré avec succès",
    "saveStateError": "Échec de l'enregistrement",
    "saveStateBlocked": "Non enregistré - champs obligatoires non renseignés"
  },
  "incidentReport": {
    "incidentReport": "Rapport d'incident",
    "metaInformation": "Métadonnées",
    "generalInformation": "Informations générales",
    "bulletinInformation": "Informations bulletin",
    "locationInformation": "Informations localisation",
    "avalancheInformation": "Informations sur l'avalanche",
    "groupInformation": "Informations sur le groupe",
    "victimInformation": "Informations sur la personne",
    "involvementsFatalitiesBurials": "Personnes impliquées, victimes et ensevelissements",
    "incidentAnalysis": "Analyse de l'incident",
    "incidentAttachments": "Pièces jointes et liens",
    "author": "Auteur",
    "authorAffiliation": "Organisation de l'auteur",
    "dateTime": "Date/heure",
    "updatedAt": "Dernière mise à jour",
    "publishedAt": "Publié le :",
    "timeAccuracy": "Précision horaire ",
    "sourceOfInformation": "Source de l'information",
    "personInvolvement": "Implication de personnes",
    "otherDamages": "Autres dommages",
    "damagedAssets": "Biens endommagés",
    "otherDamagesComment": "Autres dommages - Remarque",
    "publicAvalancheWarningService": "Service public de Prévision des Avalanches",
    "publicAvalancheWarningServiceOutside": "En dehors de la région d'alerte d'un service de prévision d'avalanches",
    "dangerRating": "Degré de danger ",
    "avalancheProblem": "Situation avalancheuse typique",
    "problemType": "Situation avalancheuse typique",
    "aspects": "Expositions",
    "elevationLowerBound": "Limite inférieure",
    "elevationUpperBound": "Limite supérieure",
    "snowpackStability": "Stabilité du manteau neigeux",
    "frequency": "Fréquence",
    "dangerPattern": "Modèle de risques",
    "reportStatus": "Statut du rapport",
    "publicExternalLinks": "Liens externes destinés au grand public",
    "privateExternalLinks": "Liens externes contenant des informations confidentielles",
    "privateExternalDatabaseLinks": "Lien vers des bases de données externes",
    "generalInformationComment": "Commentaire sur les informations générales",
    "bulletinInformationComment": "Commentaire sur les informations relatives au bulletin d'avalanches",
    "location": "Localisation",
    "country": "Pays",
    "region": "Région de prévision",
    "municipality": "Commune",
    "avalancheRegion": "Microrégion",
    "latitude": "Latitude",
    "longitude": "Longitude",
    "locationAccuracy": "Précision de localisation",
    "lineCoordinatesText": "Coordonnées de la ligne",
    "polygonCoordinatesText": "Coordonnées du polygone",
    "locationInformationComment": "Commentaire informations localisation",
    "locationType": {
      "Point": "Point",
      "Line": "Ligne",
      "Polygon": "Polygone"
    },
    "anonymousGroupIdentifier": "Identifiant anonyme du groupe",
    "groupAffiliation": "Organisation du groupe",
    "groupType": "Type de groupe",
    "groupSize": "Taille du groupe",
    "groupSizeAccuracy": "Précision taille du groupe",
    "incidentTerrainType": "Type de terrain",
    "typeOfControlledTerrain": "Type de terrain sécurisé",
    "incidentActivity": "Activité",
    "travelDirection": "Sens de déplacement",
    "vehicleType": "Type de véhicule",
    "avalancheGear": "Équipement de secours",
    "groupInformationComment": "Commentaire informations groupe",
    "numberOfGroups": "Nombre de groupes",
    "activities": "Activités",
    "terrainTypes": "Types de terrain",
    "fatalities": "Nombre de victimes",
    "injuredSurvivors": "Personnes blessées",
    "uninjuredSurvivors": "Personnes indemnes",
    "caughtOnly": "Seulement emportées",
    "fullyBuried": "Entièrement ensevelies",
    "partlyBuriedHeadCovered": "Partiellement ensevelies, tête sous la neige",
    "partlyBuriedHeadUncovered": "Partiellement ensevelies, tête en l'air",
    "partlyBuried": "Partiellement ensevelies",
    "numberInvolved": "Nombre de personnes impliquées",
    "involvementsFatalitiesBurialsComment": "Commentaire personnes impliquées, victimes et ensevelissements",
    "caught": "Emportées",
    "fatalInjured": "Décès/Blessés",
    "burialDegree": "Degré d'ensevelissement",
    "anonymousVictimIdentifier": "Identifiant anonyme de la personne",
    "age": "Âge",
    "gender": "Sexe",
    "workingAtTime": "Déplacement dans l'exercice de ses fonctions",
    "leaderAtTime": "Déplacement en tant que guide",
    "professionalCertification": "Qualification professionnelle",
    "avalancheTraining": "Formation aux avalanches",
    "yearsActive": "Nombre d'années d'expérience",
    "transceiver": "DVA",
    "shovel": "Pelle",
    "probe": "Sonde",
    "airbag": "Airbag",
    "helmet": "Casque",
    "terrainTrap": "Piège naturel",
    "burialDepth": "Profondeur d'ensevelissement",
    "burialDuration": "Durée de l'ensevelissement",
    "primaryLocationMethod": "Méthode principale de recherche",
    "rescuedBy": "Sauvée par",
    "medicalIntervention": "Prise en charge médicale",
    "estimatedTimeOfDeath": "Heure estimée du décès",
    "causeOfDeath": "Cause du décès",
    "respiratoryCavity": "Cavité respiratoire",
    "injurySeverity": "Gravité de la blessure",
    "victimInformationComment": "Commentaire informations victime",
    "multipleAvalanches": "Plusieurs avalanches",
    "avalancheSize": "Taille d'avalanche",
    "avalancheType": "Type d'avalanche",
    "relevantAvalancheProblem": "Situation avalancheuse particulière",
    "trigger": "Facteur déclenchant",
    "natural": "Spontané",
    "person": "Personne",
    "additionalLoad": "Surcharge",
    "explosives": "Charge explosive",
    "vehicle": "Véhicule",
    "accidentalControlled": "Accidentel/contrôlé",
    "remoteTriggering": "Déclenchement à distance",
    "startZoneAspect": "Exposition de la zone de rupture",
    "startZoneAspectAccuracy": "Précision de l'exposition",
    "startZoneElevation": "Altitude de la zone de rupture",
    "startZoneElevationAccuracy": "Précision de l'altitude",
    "startZoneIncline": "Pente de la zone de rupture",
    "startZoneTerrainType": "Type de terrain en zone de rupture",
    "slabWidth": "Largeur de la plaque",
    "crownDepthAvg": "Épaisseur moyenne de la rupture",
    "crownDepthMin": "Épaisseur minimum de la rupture",
    "crownDepthMax": "Épaisseur maximum de la rupture",
    "avalancheLength": "Longueur d'avalanche",
    "weakLayerName": "Nom de la couche fragile",
    "weakLayerGrainType1": "Formes des grains de la couche fragile (1)",
    "weakLayerGrainSize1": "Taille des grains de la couche fragile (1)",
    "weakLayerGrainType2": "Formes des grains de la couche fragile (2)",
    "weakLayerGrainSize2": "Taille des grains de la couche fragile (2)",
    "weakLayerLocation": "Position de la couche fragile dans le manteau neigeux",
    "bedSurfaceStepped": "Provoqué des fissures dans les couches plus profondes ?",
    "startZoneMoisture": "Humidité dans la zone de rupture",
    "depositMoisture": "Humidité des dépôts",
    "depositHeight": "Hauteur des dépôts",
    "depositWidth": "Largeur des dépôts",
    "debrisType": "Type de dépôt",
    "debrisDensity": "Densité du dépôt",
    "depositElevation": "Altitude des dépôts",
    "avalancheDetailsComment": "Commentaire détails de l'avalanche",
    "incidentLedePublic": "Publier résumé succinct ?",
    "incidentLede": "Résumé succinct",
    "incidentDescriptionPublic": "Publier description de l'incident ?",
    "incidentDescription": "Description de l'incident",
    "weatherDescriptionPublic": "Publier description de la météo ?",
    "weatherDescription": "Description de la météo",
    "avalancheDescriptionPublic": "Publier description de l'avalanche ?",
    "avalancheDescription": "Description de l'avalanche",
    "snowpackDescriptionPublic": "Publier description du manteau neigeux ?",
    "snowpackDescription": "Description du manteau neigeux",
    "takeAwaysPublic": "Publier les principales conclusions ?",
    "takeAways": "Principales conclusions ?",
    "recentSlabAvalanches": "Avalanches de plaque récentes",
    "signsOfInstability": "Signes d'instabilité",
    "recentLoading": "Accumulation récente de neige",
    "criticalWarming": "Réchauffement critique",
    "incidentAnalysisComment": "Commentaire analyse de l'incident",
    "uuid": "UUID",
    "dateAdded": "Date ajoutée",
    "dateCreated": "Date créée",
    "file": "Fichier",
    "fileName": "Nom du fichier",
    "mediaType": "Type de support",
    "attachmentTags": "Tags",
    "altText": "Texte alternatif",
    "credit": "Crédit photo",
    "caption": "En-tête",
    "public": "Public",
    "attachmentCategory": "Catégorie"
  },
  "incidentReportHelp": {
    "author": "",
    "authorAffiliation": "",
    "dateTime": "",
    "timeAccuracy": "Précisez la date et l'heure de l'avalanche.",
    "sourceOfInformation": "Précisez les sources de l'information.",
    "personInvolvement": "Sélectionnez « Oui » si l'avalanche a été déclenchée par des personnes (y compris à distance) ou si des personnes ont été emportées par les masses de neige en mouvement.",
    "otherDamages": "Sélectionnez « Oui » si l'avalanche a causé des dommages matériels ou endommagé d'autres biens de valeur.",
    "damagedAssets": "Précisez la nature des objets endommagés.",
    "otherDamagesComment": "Fournissez des informations supplémentaires sur les objets endommagés.",
    "publicAvalancheWarningService": "Nom de l'organisme dont relève la zone où l'avalanche s'est produite.",
    "publicAvalancheWarningServiceOutside": "Cocher si l'incident s'est produit en dehors de la zone de prévision d'un service de prévision d'avalanches.",
    "dangerRating": "Indice de risque d'avalanche accessible au public, valable à la date, à l'heure et au lieu de l'incident (y compris l'altitude et l'exposition, le cas échéant).",
    "avalancheProblem": "Sélectionnez le(s) risque(s) d'avalanche EAWS prévu(s) pour ce jour et cet endroit. Sélectionnez « Aucun » si aucun risque d'avalanche n'a été signalé pour ce jour.",
    "problemType": "Sélectionnez le(s) risque(s) d'avalanche EAWS prévu(s) pour ce jour et cet endroit. Sélectionnez « Aucun » si aucun risque d'avalanche n'a été signalé pour ce jour.",
    "aspects": "",
    "elevationLowerBound": "",
    "elevationUpperBound": "",
    "snowpackStability": "",
    "frequency": "",
    "dangerPattern": "Sélectionnez le(s) type(s) de risques prévu(s) pour ce jour et cet endroit.",
    "reportStatus": "Brouillon : pas encore accessible au public ; phase de collecte initiale des données. Incomplet : toutes les informations n'ont pas encore été saisies ou ne sont pas encore disponibles ; visible par le public, mais peut contenir des informations non encore vérifiées. En cours de vérification : toutes les informations ont été saisies ; en attente de vérification par une personne responsable. Terminé : toutes les informations disponibles ont été complétées ; statut définitif.",
    "publicExternalLinks": "",
    "privateExternalLinks": "",
    "privateExternalDatabaseLinks": "Relier cet incident à d'autres bases de données.",
    "generalInformationComment": "Ajouter toute information pertinente.",
    "bulletinInformationComment": "Ajouter toute information pertinente.",
    "location": "Brève description du lieu. Utiliser le nom de la montagne la plus proche ou d'un repère géographique caractéristique.",
    "country": "",
    "region": "",
    "municipality": "",
    "avalancheRegion": "Microrégions",
    "latitude": "Indiquer les coordonnées du centre du front de rupture.",
    "longitude": "Indiquer les coordonnées du centre du front de rupture.",
    "locationAccuracy": "Évaluer la précision des coordonnées en termes de latitude et de longitude.",
    "lineCoordinatesText": "Indiquer les coordonnées du couloir d'avalanche (une paire de coordonnées de latitude et de longitude par ligne).",
    "polygonCoordinatesText": "Indiquer les coordonnées du couloir d'avalanche (une paire de coordonnées de latitude et de longitude par ligne).",
    "locationInformationComment": "Ajouter toute information pertinente.",
    "anonymousGroupIdentifier": "L'identifiant anonyme sert à identifier de manière unique le groupe tout au long du rapport. Vous pouvez, par exemple, faire référence au « Groupe 1 », au « Groupe 2 », etc. Si cela s'avère utile, vous pouvez ajouter des informations supplémentaires afin de mieux distinguer les groupes les uns des autres. Le cas échéant, vous pouvez également utiliser ce même identifiant anonyme dans la description de l'incident.",
    "groupAffiliation": "Sélectionner le groupe auquel appartenait cette personne.",
    "groupType": "Choisir l'option qui décrit le mieux le type de groupe.",
    "groupSize": "Indiquer le nombre total de personnes dans le groupe.",
    "groupSizeAccuracy": "Indiquer avec quelle précision la taille du groupe est connue.",
    "incidentTerrainType": "Sélectionner le type de terrain sur lequel se trouvaient les personnes au moment de l'avalanche. Le terme « terrain libre » désigne les zones dépourvues d'infrastructures humaines.",
    "typeOfControlledTerrain": "",
    "incidentActivity": "",
    "travelDirection": "Direction du déplacement au moment de l'incident.",
    "vehicleType": "",
    "avalancheGear": "L'équipement de secours de base en cas d'avalanche comprend un détecteur de victimes d'avalanches (DVA), une pelle et une sonde. Donnez une estimation générale pour savoir si le groupe avait cet équipement avec lui. Cette information provient souvent des équipes de secours. Il n’est pas nécessaire de recenser le nombre exact d’éléments d’équipement ni l’équipement de chaque personne. La question fondamentale est la suivante : le groupe avait-il emporté du matériel de secours en cas d’avalanche ?",
    "groupInformationComment": "Ajouter toute information pertinente.",
    "numberOfGroups": "Nombre de groupes impliqués",
    "activities": "",
    "terrainTypes": "",
    "fatalities": "Toutes les personnes décédées, qu'elles soient décédées sur les lieux de l'accident ou ultérieurement des suites de leurs blessures.",
    "injuredSurvivors": "Nombre de personnes emportées par l'avalanche et blessées. Ne pas inclure des personnes décédées.",
    "uninjuredSurvivors": "Nombre de personnes emportées par l'avalanche mais n'ayant pas été blessées. Inclure également les personnes qui ont simplement été touchées par le nuage de neige.",
    "caughtOnly": "Nombre de personnes emportées par l'avalanche mais n'ayant pas été ensevelies. Ce chiffre inclut également les personnes qui ont simplement été touchées par le nuage de neige.",
    "fullyBuried": "Nombre de personnes entièrement ensevelies par l'avalanche. Une personne est considérée comme entièrement ensevelie lorsqu'aucune partie de son corps n'est visible.",
    "partlyBuriedHeadCovered": "Nombre de personnes ensevelies de telle sorte que leur tête était recouverte de neige, mais que certaines parties de leur corps, de leurs vêtements ou de leur équipement restaient visibles.",
    "partlyBuriedHeadUncovered": "Nombre de personnes ensevelies dont la tête n'était pas recouverte de neige.",
    "partlyBuried": "Nombre=partiellement recouvertes de neige, tête recouverte, sinon partiellement recouvertes (= visiblement entièrement recouvertes), tête non recouverte",
    "numberInvolved": "Nombre=Personnes emportées seulement+Entièrement ensevelies+Partiellement ensevelies",
    "involvementsFatalitiesBurialsComment": "Ajouter toute information pertinente.",
    "caught": "Indiquez si cette personne a été impliquée dans l'incident. Une personne est considérée comme impliquée si elle a été emportée par l'avalanche (qu'elle ait été ensevelie ou non), si elle a été ensevelie ou si elle a simplement été touchée par le nuage de neige.",
    "fatalInjured": "Précisez si la personne a été tuée, si elle a été blessée ou non, quelle que soit la manière dont elle a été impliquée dans l'avalanche.",
    "burialDegree": "Indiquez le degré d'ensevelissement. Une personne est considérée comme entièrement ensevelie lorsque tout son corps est recouvert de neige. En cas d'ensevelissement partiel, il convient, dans la mesure du possible, de préciser si la tête était recouverte ou non ; ces options sont à privilégier. Si cette information n'est pas disponible, sélectionnez l'option « Ensevelie partiellement ».",
    "anonymousVictimIdentifier": "Cette désignation sert à identifier sans ambiguïté la personne concernée tout au long du rapport, sans utiliser son nom. Utilisez par exemple « Personne 1 », « Personne 2 », etc. ou, dans le cas d’un accident de motoneige, « Conducteur·trice 1 », « Conducteur·trice 2 ». Si cela s'avère utile, vous pouvez ajouter des précisions permettant de mieux distinguer les personnes, par exemple « survivant de sexe masculin », « survivante de sexe féminin » ou « décédé de sexe masculin ». Le cas échéant, vous pouvez également utiliser cette même désignation dans la description de l'incident.",
    "age": "",
    "gender": "",
    "workingAtTime": "Précisez si la personne exerçait une activité professionnelle au moment des faits, que ce soit dans le cadre d'un emploi rémunéré ou d'une activité bénévole.",
    "leaderAtTime": "Était-il évident que la personne impliquée agissait en qualité de guide du groupe ?",
    "professionalCertification": "Indiquez la qualification professionnelle ou la certification de la personne.",
    "avalancheTraining": "Quelle est la formation sécurité-avalanche la plus avancée que la victime a suivie ?",
    "yearsActive": "Depuis combien d'années la personne avait de l'expérience dans cette activité avant l'incident.",
    "transceiver": "Précisez si la personne portait un détecteur de victimes d'avalanches et si celui-ci était réglé en mode « émission ».",
    "shovel": "",
    "probe": "",
    "airbag": "",
    "helmet": "",
    "terrainTrap": "Si un piège naturel était impliqué, merci de préciser de quel type il s'agissait.",
    "burialDepth": "Indiquez la profondeur d'ensevelissement en mètres, avec une précision de 0,1 m. La profondeur d'ensevelissement est déterminée par la distance entre la surface de la neige et les voies respiratoires de la personne ensevelie.",
    "burialDuration": "Indiquez la durée d'ensevelissement de la victime en minutes. La durée d'ensevelissement correspond à la période comprise entre le moment où la personne a été ensevelie pour la première fois et celui où ses voies respiratoires ont été dégagées.",
    "primaryLocationMethod": "Indiquez la méthode principale utilisée pour localiser la victime.",
    "rescuedBy": "",
    "medicalIntervention": "Quelles mesures médicales ont été prises, que ce soit par les membres du groupe ou par les secours?",
    "estimatedTimeOfDeath": "Estimez aussi précisément que possible l’heure du décès de la victime. Cette information ne doit pas nécessairement correspondre à l'heure officielle du décès, car dans de nombreux cas, le décès n'est constaté qu'à l'hôpital.",
    "causeOfDeath": "Cause probable du décès",
    "respiratoryCavity": "Voies respiratoires dégagées",
    "injurySeverity": "Grave : blessure grave, souvent mettant la vie en danger, nécessitant des soins médicaux immédiats et pouvant entraîner des séquelles permanentes ou la mort (par exemple, fractures, traumatismes crâniens, perte de conscience, hémorragies importantes). Modérée : blessure plus grave qu’une blessure légère, mais ne mettant pas immédiatement la vie en danger. En règle générale, un traitement médical est nécessaire, mais on s'attend à un rétablissement complet sans séquelles majeures à long terme (par exemple : luxations, entorses ou claquages, coupures profondes). Légère : une blessure mineure pouvant être traitée par des premiers secours simples et ne nécessitant pas de soins médicaux professionnels (par exemple : petites coupures, écorchures ou contusions).",
    "victimInformationComment": "Ajouter toute information pertinente.",
    "multipleAvalanches": "Sélectionnez « Oui » si l'incident était lié à plusieurs avalanches. Dans ce cas, saisissez les informations relatives à l'avalanche la plus grave dans la section « Détails de l'avalanche » et décrivez les autres avalanches dans la section « Commentaires avalanches ».",
    "avalancheSize": "Évaluez le potentiel destructeur de l'avalanche sur la base des dépôts qu'elle a laissés et attribuez-lui une taille conformément à la norme EAWS. La classe 1 correspond à la plus petite classe. Les demi-classes ne sont en principe pas définies, mais peuvent être utilisées pour les avalanches se situant entre deux classes de taille ; elles sont alors classées dans la catégorie inférieure (par exemple, une avalanche de taille 2,5 est classée en 2).",
    "avalancheType": "Sélectionnez dans la liste le type d'avalanche correspondant au type de rupture. Si plusieurs types correspondent, choisissez celui qui convient le mieux et précisez les détails supplémentaires dans la description de l'incident.",
    "relevantAvalancheProblem": "Sélectionnez la situation avalancheuse EAWS la plus pertinente.",
    "trigger": "Naturelle : déclenchée sans intervention humaine. Personne : déclenchée par une ou plusieurs personnes. Explosion : déclenchée par des explosifs, de l'artillerie ou du gaz. Véhicule : déclenché par un véhicule (par exemple, une dameuse ou un hélicoptère). Inconnue : la cause du déclenchement est inconnue ou incertaine.",
    "natural": "Naturelle : provoquée par des phénomènes météorologiques (par exemple, chutes de neige, vent, température) ; rupture de corniche : provoquée par la rupture spontanée d'une corniche ; tremblement de terre : provoquée par un tremblement de terre ; chute de glace : provoquée par la rupture d'un bloc de glace ; chute de pierres : provoquée par une chute de pierres",
    "person": "Accidentelle : par exemple, les skieurs, les snowboardeurs, les randonneurs, les grimpeurs. De manière contrôlée : par exemple, skieur effectuant délibérément des virages en zigzag sur une pente ou une corniche.",
    "additionalLoad": "Surcharge faible : skieur ou snowboardeur isolé, groupe bien espacé (≥ 10 m) ou randonneur en raquettes ; surcharge importante : groupe très rapproché (< 10 m), personne seule à pied, skieur ou snowboardeur en chute.",
    "explosives": "",
    "vehicle": "",
    "accidentalControlled": "",
    "remoteTriggering": "On parle de déclenchement à distance lorsque l'avalanche se déclenche à une certaine distance (généralement plus de 5 m) du point de déclenchement présumé. La neige au niveau du point de déclenchement lui-même ne se rompt pas.",
    "startZoneAspect": "Indiquez l'exposition de la zone de départ. Si l'avalanche s'étend sur plusieurs expositions, utilisez l'exposition moyenne et précisez les détails supplémentaires dans la description de l'incident.",
    "startZoneAspectAccuracy": "Indiquez si l'exposition de la zone de rupture est sûre ou incertaine. L'indication est considérée comme incertaine lorsque des écarts supérieurs à ±30° sont possibles.",
    "startZoneElevation": "Indiquez l'altitude du front de rupture en mètres au-dessus du niveau de la mer. Prenez comme référence le point le plus élevé du front de rupture arrondi à la cinquantaine de mètres la plus proche (par exemple 2 550 m ou 2 600 m).",
    "startZoneElevationAccuracy": "",
    "startZoneIncline": "Pente dans la zone de rupture (en °), arrondie aux 5° les plus proches (par exemple 30°, 35°, 40°).",
    "startZoneTerrainType": "Sélectionnez les types de relief qui caractérisent la zone de rupture de l'avalanche.",
    "slabWidth": "Largeur de la plaque de neige en mètres. Celle-ci peut être estimée à partir d'observations sur le terrain ou déterminée cartographiquement à l'aide des coordonnées des flancs.",
    "crownDepthAvg": "Épaisseur moyenne de la rupture en cm, mesurée verticalement et arrondie aux 10 cm les plus proches. Cette valeur peut être estimée à partir d'observations sur le terrain (si une seule valeur est indiquée pour l'épaisseur de la rupture, celle-ci correspond généralement à l'épaisseur moyenne) ou, si possible, calculée à partir des épaisseurs minimale et maximale de la rupture.",
    "crownDepthMin": "Épaisseur minimale de la rupture en cm, mesurée verticalement et arrondie aux 10 cm les plus proches. Cette valeur est généralement estimée à partir d'observations sur le terrain.",
    "crownDepthMax": "Épaisseur maximale de la rupture en cm, mesurée verticalement et arrondie au 10 cm les plus proches. Cette valeur est généralement estimée à partir d'observations sur le terrain.",
    "avalancheLength": "Distance d'écoulement le long du terrain, du point le plus haut du front de rupture jusqu'au point le plus bas du dépôt (en m). Cette valeur peut être estimée à partir d'observations sur le terrain ou déterminée à l'aide des coordonnées cartographiées des zones de départ et d'arrivée.",
    "weakLayerName": "Indiquez le nom de la couche fragile, si vous le connaissez.",
    "weakLayerGrainType1": "Forme des grains de la couche fragile primaire.",
    "weakLayerGrainSize1": "Taille des grains arrondie au 0,25 mm le plus proche.",
    "weakLayerGrainType2": "Forme des grains de la couche fragile secondaire.",
    "weakLayerGrainSize2": "Taille des grains arrondie au 0,25 mm le plus proche.",
    "weakLayerLocation": "Dans la neige fraîche : la couche fragile se trouve dans la neige récemment tombée ou transportée lors de la période actuelle de chute de neige ou de transport ; À l'interface avec la neige ancienne : la couche fragile se trouve à la limite entre la neige fraîche et la neige ancienne (par exemple, du givre de surface sur la surface de la neige ancienne avant qu'elle ne soit recouverte) ; Dans le manteau neigeux ancien : la couche fragile se trouve dans la partie centrale ou supérieure du manteau neigeux ancien ; Près du sol : la couche fragile se trouve dans la partie inférieure du manteau neigeux, près du sol, généralement constituée de cristaux facettés bien développés. Les avalanches qui se déclenchent sur cette couche fragile mettent souvent le sol à nu.",
    "bedSurfaceStepped": "Sélectionnez « Oui » si l'avalanche a provoqué des fissures dans les couches plus profondes ",
    "startZoneMoisture": "",
    "depositMoisture": "",
    "depositHeight": "Hauteur maximale du dépôt",
    "depositWidth": "Largeur maximale du dépôt",
    "debrisType": "Choisir l'option qui décrit le mieux la composition du dépôt peu après le départ de l'avalanche.",
    "debrisDensity": "Densité du dépôt, exprimée sous forme de médiane de plusieurs mesures effectuées à différents endroits au sein du dépôt.",
    "depositElevation": "Altitude du point le plus bas du dépôt d'avalanche en mètres au-dessus du niveau de la mer.",
    "avalancheDetailsComment": "Ajouter toute information pertinente.",
    "incidentLedePublic": "",
    "incidentLede": "Texte court (500 caractères maximum) résumant l'essentiel de l'incident. Indiquez ce qui s'est passé, où et quand cela s'est produit, et pourquoi cet incident mérite d’être signalé. Soyez concis et tenez-vous-en aux faits, en mettant en avant les conséquences les plus importantes (par exemple : personnes impliquées, personnes enfouies, victimes, circonstances inhabituelles).",
    "incidentDescriptionPublic": "",
    "incidentDescription": "Décrivez l'incident de manière claire et chronologique, en évitant tout jugement ou toute accusation. Précisez ce que faisait le groupe à ce moment-là ; où il se trouvait (type de terrain, altitude, exposition si vous la connaissez) ; comment l'avalanche s'est déclenchée ; combien de personnes ont été impliquées, ensevelies, blessées ou tuées ; qui est intervenu ; ainsi que les détails essentiels du sauvetage. Ajoutez toute autre observation pertinente permettant de reconstituer les faits.",
    "weatherDescriptionPublic": "",
    "weatherDescription": "Décrivez les conditions météorologiques qui ont influencé l'avalanche, notamment des facteurs tels que la formation d'une couche fragile, le développement d'une plaque, une surcharge récente ou un réchauffement. Le cas échéant, renvoyez aux annexes pertinentes (par exemple, des données de stations météorologiques ou des graphiques).",
    "avalancheDescriptionPublic": "",
    "avalancheDescription": "Décrivez la ou les avalanches en utilisant des termes clairs et objectifs. Précisez le type d’avalanche, sa taille et ses dimensions (par exemple : largeur, épaisseur de la rupture, distance parcourue). Précisez comment elle a été déclenchée (déclenchement naturel, d'origine humaine, à distance) et comment elle s'est comportée (par exemple, propagation, étendue). Indiquez toutes les caractéristiques mesurables ou observées. Utilisez la rubrique « Description de l'incident » pour fournir des détails sur la manière dont les personnes ont été emportées par l'avalanche, le lieu où cela s'est produit, les détails des opérations de sauvetage, etc.",
    "snowpackDescriptionPublic": "",
    "snowpackDescription": "Expliquez la structure du manteau neigeux et les conditions qui ont contribué à l'avalanche. Identifiez les couches fragiles pertinentes et les caractéristiques des plaques de neige, puis décrivez leur répartition (par exemple, en fonction de l'altitude ou de l'exposition). Mentionnez les signes d'instabilité ainsi que les résultats obtenus grâce aux tests effectués sur le manteau neigeux. Concentrez-vous sur les raisons pour lesquelles le manteau neigeux était susceptible de céder.",
    "takeAwaysPublic": "",
    "takeAways": "Résumez les principaux enseignements tirés de cet incident en quelques points succincts. Tenez compte d'aspects tels que les signes avant-coureurs, la gestion des risques (par exemple, skier un par un), l'utilisation du matériel de sécurité, les pièges naturels et la composition du groupe.",
    "recentSlabAvalanches": "Faites appel à votre bon sens pour répondre à la question suivante : y a-t-il des signes d'avalanches de plaque dans la zone, datant d'aujourd'hui ou d'hier ? Consultez les informations fournies par le groupe lui-même, les rapports des équipes de recherche et de sauvetage ou d'autres utilisateurs de la zone qui indiquent si d'autres avalanches ont été signalées.",
    "signsOfInstability": "Faites preuve de bon sens pour répondre à la question suivante : observe-t-on des signes d'instabilité du manteau neigeux, notamment des « woumfs », des fissures qui se propagent ou des bruits sourds ? Consultez les informations fournies par le groupe lui-même, les rapports des équipes de recherche et sauvetage ou d'autres usagers de la zone, qui indiquent si des signes d'instabilité ont été constatés.",
    "recentLoading": "Faites appel à votre bon sens pour répondre à la question suivante : y a-t-il eu, au cours des dernières 48 heures, des chutes de neige d'environ 30 cm ou plus, un transport important de neige par le vent ou de la pluie ?",
    "criticalWarming": "Faites appel à votre bon sens pour répondre à la question suivante : y a-t-il eu récemment une hausse rapide de la température jusqu'à près de 0 °C, ou la couche supérieure du manteau neigeux est-elle humide en raison d'un fort ensoleillement, de températures de l'air supérieures à zéro ou de la pluie ?",
    "incidentAnalysisComment": "Pour plus d'informations",
    "uuid": "UUID",
    "dateAdded": "La date est déterminée à partir de l'heure de téléchargement de la pièce jointe.",
    "dateCreated": "Date à laquelle l'annexe a été établie ou créée",
    "file": "Fichier",
    "fileName": "Repris à partir du nom de fichier d'origine de la pièce jointe mise en ligne.",
    "mediaType": "",
    "attachmentTags": "",
    "altText": "",
    "credit": "",
    "caption": "",
    "public": "",
    "attachmentCategory": ""
  },
  "sourceOfInformation": {
    "PublicObservation": "Observation publique",
    "AWSInternal": "Service de prévision d'avalanches interne",
    "AWSObserver": "Observateur du service de prévision d'avalanches",
    "DispatchCentre": "Centre de contrôle",
    "Police": "Police",
    "MountainRescue": "Secours en montagne",
    "Other": "Autres"
  },
  "personInvolvement": {
    "Yes": "Personnes emportées",
    "No": "Pas de personnes emportées",
    "Unknown": "Événement (inconnu)"
  },
  "otherDamages": {
    "Yes": "Oui",
    "No": "Non"
  },
  "damagedAssets": {
    "Vehicle": "Véhicule",
    "Forest": "Forêt",
    "Agriculture": "Agriculture",
    "Livestock": "Bétail",
    "UtilitiesTechnicalInfrastructure": "Services publics ou infrastructures techniques",
    "Other": "Autres"
  },
  "timeAccuracy": {
    "exact": "exacte",
    "PT15M": "± 15 min",
    "PT30M": "± 30 min",
    "PT1H": "± 1 h",
    "PT2H": "± 2 h",
    "PT4H": "± 4 h",
    "PT6H": "± 6 h",
    "PT12H": "± 12 h",
    "P1D": "± 1 d",
    "P2D": "± 2 d",
    "P3D": "± 3 d",
    "unknown": "inconnue"
  },
  "reportStatus": {
    "Draft": "Ébauche",
    "Incomplete": "Incomplet",
    "InReview": "En cours d'évaluation",
    "Verified": "Vérifié"
  },
  "locationAccuracy": {
    "exact": "exacte",
    "within15m": "± 15 m",
    "within30m": "± 30 m",
    "within100m": "± 100 m",
    "within250m": "± 250 m",
    "within500m": "± 500 m",
    "within1km": "± 1 km",
    "within2km": "± 2 km",
    "within5km": "± 5 km",
    "within10km": "± 10 km",
    "within20km": "± 20 km",
    "within50km": "± 50 km",
    "unknown": "inconnue"
  },
  "groupType": {
    "RecreationalFamilyFriends": "Loisirs famille/amis",
    "Club": "Club",
    "Commercial": "Commercial",
    "Industrial": "Industriel",
    "Solo": "Solo",
    "Unknown": "Inconnu",
    "Other": "Autres"
  },
  "groupSizeAccuracy": {
    "Exact": "Exact",
    "Approximately": "Environ",
    "AtLeast": "Au  moins",
    "Unknown": "Inconnu"
  },
  "incidentTerrainType": {
    "FreeTerrain": "Zone non sécurisée",
    "ControlledTerrainOpen": "Zone sécurisée : Ouverte",
    "ControlledTerrainClosed": "Zone sécurisée : Interdite",
    "Unknown": "Inconnu"
  },
  "typeOfControlledTerrain": {
    "IndoorInsideBuilding": "Dans un bâtiment",
    "Street": "Route",
    "TrainTrack": "Voie ferrée",
    "SkiAreaResort": "Station de ski",
    "CrossCountryTrack": "Piste de ski de fond",
    "SledgingTrack": "Piste de luge",
    "Other": "Autres"
  },
  "incidentActivity": {
    "Touring": "Randonnée à ski",
    "Freeriding": "Ski freeride",
    "SkiingSnowboarding": "Ski/snowboard",
    "Snowmobiling": "Motoneige",
    "Mountaineering": "Alpinisme",
    "IceClimbing": "Escalade de glace",
    "Snowshoeing": "Randonnée en raquettes",
    "HikingOnFoot": "Randonnée à pied",
    "CrossCountrySkiing": "Ski de fond",
    "HuntingFishing": "Chasse/Pêche",
    "Sledging": "Luge",
    "Snowbiking": "Vélo de neige",
    "Biking": "Vélo",
    "InsideVehicle": "Dans un véhicule",
    "Unknown": "Inconnu",
    "Other": "Autres"
  },
  "travelDirection": {
    "Ascending": "Montant",
    "Descending": "Descendant",
    "Stationary": "À l'arrêt",
    "Traversing": "Traversant",
    "MovingOnPeaksRidges": "Déplacement sur des sommets/crêtes",
    "SnowmobileHighMarking": "Snowmobile High Marking",
    "CrossingRunouts": "Traversant des de zones d'étalement",
    "Other": "Autres"
  },
  "vehicleType": {
    "Car": "Voiture",
    "Bus": "Bus",
    "SnowPlower": "Déneigeuse",
    "Snowcat": "Engin de damage",
    "Other": "Autres"
  },
  "avalancheGear": {
    "All": "Tout",
    "Some": "Quelques",
    "None": "Aucune",
    "Unknown": "Inconnu"
  },
  "natural": {
    "Natural": "Spontanée (conséquence de phénomènes météorologiques, par exemple chutes de neige, vent, température)",
    "CorniceFall": "Rupture de corniche, spontanée",
    "Earthquake": "Séisme",
    "IceFall": "Chute de sérac",
    "RockFall": "Chute de pierres"
  },
  "person": {
    "PersonAccidental": "Accidentel",
    "PersonControlled": "Contrôlé"
  },
  "explosives": {
    "Artillery": "Artillerie",
    "CaseCharge": "Charge explosive placée dans un sac au pied de la pente",
    "CorniceControlledByExplosives": "Corniche, rupture par minage",
    "HelicopterDeployedGasExploder": "Dispositif d'explosion gazeuse héliporté (par exemple DaisyBell)",
    "HandThrownOrPlaced": "Grenadage à main",
    "GasExploder": "Dispositif d'explosion gazeuse",
    "HelicopterBomb": "Héligrenadage",
    "Avalauncher": "Avalancheur et autres types de lanceurs",
    "PrePlacedRemotelyDetonated": "Installation fixe de déclenchement à distance par charge explosive",
    "TramOrRopewayDelivery": "Téléphérique de minage",
    "Other": "Autres"
  },
  "vehicle": {
    "OverSnowVehicle": "Véhicules tout-terrain (engins de damage, matériel d'entretien, etc.)",
    "Snowmobile": "Motoneige",
    "Helicopter": "Hélicoptère (p. ex. lors de l'atterrissage ou de l'approche)",
    "Other": "Autres"
  },
  "startZoneElevationAccuracy": {
    "exact": "exacte",
    "within50m": "± 50 m",
    "within100m": "± 100 m",
    "within200m": "± 200 m",
    "unknown": "inconnue"
  },
  "startZoneTerrainType": {
    "AlpineBowl": "Cirque",
    "Couloir": "Couloir",
    "NearRidgeCrest": "Zone proche de la crête",
    "SparselyTreed": "Peu boisé",
    "OpenForest": "Forêt ouverte",
    "DenseForest": "Forêt dense",
    "ForestGlade": "Clairière",
    "Glacier": "Glacier",
    "OpenSlope": "Terrain dégagée",
    "Ridge": "Arête",
    "ExtremeRockyTerrain": "Terrain parsemé de rochers",
    "BaseOfRockFace": "Pied de la paroi rocheuse",
    "WoodPath": "Chemin forestier",
    "LeewardSlope": "Versant sous le vent",
    "WindwardSlope": "Versant au vent",
    "IceWaterfall": "Cascade de glace",
    "Other": "Autres"
  },
  "weakLayerLocation": {
    "WithinNewSnow": "Dans la neige fraîche",
    "AtInterfaceWithOldSnow": "À l'interface avec la neige ancienne",
    "WithinOldSnowpack": "Dans le manteau neigeux ancien",
    "NearTheGround": "Près du sol"
  },
  "debrisType": {
    "Fine": "Fin",
    "Blocks": "Fritté",
    "Hard": "Dure",
    "Soft": "Doux",
    "Rocks": "Rochers",
    "Trees": "Arbres",
    "Other": "Autres"
  },
  "startZoneMoisture": {
    "Dry": "Sec",
    "Moist": "Mouillé",
    "Wet": "Humide",
    "Unknown": "Inconnu"
  },
  "depositMoisture": {
    "Dry": "Sec",
    "Moist": "Mouillé",
    "Wet": "Humide"
  },
  "bedSurfaceStepped": {
    "Yes": "Oui",
    "No": "Non"
  },
  "multipleAvalanches": {
    "Yes": "Oui",
    "No": "Non"
  },
  "avalancheType": {
    "slab": "plaque de neige",
    "loose": "avalanche de neige meuble",
    "glide": "avalanche de glissement",
    "cornice": "corniche",
    "unknown": "inconnue"
  },
  "avalancheSize": {
    "small": "petite",
    "small_medium": "petite à moyenne",
    "medium": "moyenne",
    "medium_large": "moyenne à grande",
    "large": "grande",
    "large_very_large": "grande à très grande",
    "very_large": "très grande",
    "very_large_extreme": "très grande à extrême",
    "extreme": "extrême",
    "unknown": "inconnue"
  },
  "trigger": {
    "natural": "Spontanée",
    "person": "Personne",
    "explosives": "Charges explosives",
    "vehicle": "Véhicule",
    "unknown": "Inconnu",
    "Other": "Autres"
  },
  "startZoneAspectAccuracy": {
    "Accurate": "Précis",
    "Uncertain": "Incertain"
  },
  "remoteTriggering": {
    "Yes": "Oui",
    "No": "Non"
  },
  "additionalLoad": {
    "High": "Fort",
    "Low": "Faible"
  },
  "accidentalControlled": {
    "Accidental": "Accidentel",
    "Controlled": "Contrôlé"
  },
  "caught": {
    "Involved": "Impliquée",
    "NotInvolved": "Pas impliquée",
    "Unknown": "Inconnu"
  },
  "fatalInjured": {
    "Fatal": "Mortel",
    "Injured": "Blessé",
    "Uninjured": "Indemne",
    "Unknown": "Inconnu"
  },
  "burialDegree": {
    "FullyBuried": "Entièrement ensevelies",
    "PartlyBuriedHeadCovered": "Partiellement ensevelies, tête sous la neige",
    "PartlyBuriedHeadUncovered": "Partiellement ensevelies, tête en l'air",
    "PartlyBuried": "Partiellement ensevelies",
    "NotBuried": "Pas ensevelie",
    "Unknown": "Inconnu"
  },
  "age": {
    "UpTo13": "≤ 13",
    "From14To20": "14–20",
    "From21To30": "21–30",
    "From31To40": "31–40",
    "From41To50": "41–50",
    "From51To60": "51–60",
    "From61To70": "61–70",
    "From71": "≥ 71"
  },
  "gender": {
    "Female": "Femme",
    "Male": "Homme",
    "Other": "Autres"
  },
  "country": {
    "Austria": "Autriche",
    "Germany": "Allemagne",
    "Italy": "Italie",
    "Switzerland": "Suisse",
    "Other": "Autres"
  },
  "workingAtTime": {
    "Yes": "Oui",
    "No": "Non"
  },
  "leaderAtTime": {
    "Yes": "Oui",
    "No": "Non"
  },
  "professionalCertification": {
    "None": "Aucune",
    "IFMGAGuide": "Guide UIAGM",
    "FullSkiGuide": "Guide de ski",
    "SkiInstructor": "Moniteur/monitrice de ski",
    "ApprenticeGuide": "Aspirant/e guide de montagne",
    "AvalancheProfessional": "Professionnel/le spécialiste des avalanches",
    "AvalancheEducator": "Formateur/formatrice avalanches",
    "Other": "Autres"
  },
  "avalancheTraining": {
    "None": "Aucune",
    "Awareness": "Sensibilisation",
    "BasicREC": "Formation de base loisirs",
    "AdvancedREC": "Formation avancée loisirs",
    "Professional": "Professionnel",
    "Other": "Autres"
  },
  "yearsActive": {
    "UpTo2Years": "≤ 2 ans",
    "From3To9Years": "3–9 ans",
    "From10Years": "≥ 10 ans"
  },
  "transceiver": {
    "NoTransceiver": "Pas de DVA",
    "TransceiverOn": "DVA : marche",
    "TransceiverOff": "DVA : arrêt"
  },
  "shovel": {
    "Yes": "Oui",
    "No": "Non"
  },
  "probe": {
    "Yes": "Oui",
    "No": "Non"
  },
  "airbag": {
    "NoAirbag": "Pas d'airbag",
    "AirbagDeployed": "Airbag : activé",
    "AirbagUndeployed": "Airbag : désactivé"
  },
  "helmet": {
    "Yes": "Oui",
    "No": "Non"
  },
  "terrainTrap": {
    "None": "Aucune",
    "Cliff": "Falaise",
    "Trees": "Arbres",
    "Gully": "Ravine",
    "Depression": "Dépression de terrain",
    "Bench": "Niveau de terrain",
    "Boulder": "Rocher",
    "CrevasseOrBergschrund": "Crevasse ou fissure de glacier",
    "Other": "Autres"
  },
  "primaryLocationMethod": {
    "NotBuried": "Pas ensevelie",
    "SelfExtraction": "Sauvetage en autonomie",
    "VisualClues": "Indices visuels",
    "TransceiverProbeShovel": "DVA, sonde, pelle",
    "SpotProbing": "Sondage aléatoire",
    "ProbeLine": "Chaîne de sondage",
    "Recco": "Recco",
    "RescueDog": "Chien d'avalanche",
    "Snowmelt": "Fonte nivale",
    "Other": "Autres"
  },
  "rescuedBy": {
    "Self": "En autonomie",
    "Companion": "Par camarade",
    "OtherGroup": "Autre groupe",
    "OrganizedRescue": "Sauvetage organisé",
    "Unknown": "Inconnu",
    "Other": "Autres"
  },
  "medicalIntervention": {
    "CPR": "Réanimation cardio-pulmonaire - RCP",
    "ALS": "Mesures de réanimation avancées",
    "ECMO": "ECMO",
    "Other": "Autres"
  },
  "estimatedTimeOfDeath": {
    "DuringTheAvalanche": "Pendant le déclenchement de l'avalanche",
    "DuringBurial": "Pendant l'ensevelissement",
    "OnSiteAfterExtrication": "Sur le lieu de l'accident, après le sauvetage",
    "DuringTransport": "Pendant le transport",
    "InHospital": "À l'hôpital"
  },
  "causeOfDeath": {
    "Asphyxiation": "Asphyxie",
    "TraumaticInjury": "Lésion traumatique",
    "Hypothermia": "Hypothermie",
    "Other": "Autres"
  },
  "respiratoryCavity": {
    "Yes": "Oui",
    "No": "Non"
  },
  "injurySeverity": {
    "Minor": "Faible",
    "Moderate": "Limité",
    "Major": "Majeur"
  },
  "recentSlabAvalanches": {
    "Present": "Présent",
    "Absent": "Absent",
    "Unknown": "Inconnu"
  },
  "signsOfInstability": {
    "Present": "Présent",
    "Absent": "Absent",
    "Unknown": "Inconnu"
  },
  "recentLoading": {
    "Present": "Présent",
    "Absent": "Absent",
    "Unknown": "Inconnu"
  },
  "criticalWarming": {
    "Present": "Présent",
    "Absent": "Absent",
    "Unknown": "Inconnu"
  },
  "attachmentTags": {
    "Picture": "Photo",
    "PoliceReport": "Rapport de police",
    "MedicalReport": "Rapport médical",
    "Other": "Autres"
  },
  "attachmentCategory": {
    "Incident": "Incident",
    "Avalanche": "Avalanche",
    "Snowpack": "Manteau neigeux",
    "Group": "Groupe",
    "Person": "Personne",
    "Weather": "Météo"
  }
}
